// extracted by mini-css-extract-plugin
module.exports = {"container":"topTournamentRow__container___1aaif","info":"topTournamentRow__info___c1WrZ","name":"topTournamentRow__name___9fnHY"};